import {
  IconSettings,
  IconCoin,
  IconBusinessplan,
  IconPrinter,
  IconFileInvoice,
  IconFriends
} from '@tabler/icons';
import { Icon } from '@iconify/react';
import peopleFill from '@iconify/icons-eva/people-fill';

const icons = {
  IconSettings,
  IconCoin,
  IconBusinessplan,
  IconPrinter,
  IconFileInvoice,
  IconFriends
};

const getIcon = (name) => <Icon icon={name} width={22} height={22} />;

const branchUser = {
  id: 'pages',
  title: 'Membership',
  type: 'group',
  children: [
    {
      id: 'customer',
      title: 'Members',
      type: 'item',
      url: '/dashboard/client',
      icon: getIcon(peopleFill),
      breadcrumbs: false
    },
    {
      id: 'membMgmt',
      title: 'Member Management',
      type: 'collapse',
      icon: icons.IconFriends,
      children: [
        {
          id: 'registermember',
          title: 'Register Internal',
          type: 'item',
          url: '/ssb/registerinternal',
          breadcrumbs: false
        },
        {
          id: 'provincessb',
          title: 'Province Ssb Upload',
          type: 'item',
          url: '/ssb/provincessb',
          target: false
        },
        {
          id: 'addDep',
          title: 'Add Dependants',
          type: 'item',
          url: '/clientportfolio/adddependant',
          breadcrumbs: false
        },
        {
          id: 'addDoc',
          title: 'Add Document',
          type: 'item',
          url: '/clientportfolio/adddocument',
          breadcrumbs: false
        },
        {
          id: 'depuplo',
          title: 'Upload Dependants',
          type: 'item',
          url: '/clientportfolio/dependantsupload',
          breadcrumbs: false
        }
      ]
    },
    {
      id: 'subs',
      title: 'Subscriptions',
      type: 'collapse',
      icon: icons.IconBusinessplan,
      children: [
        {
          id: 'fileLooksup',
          title: 'File Lookup View',
          type: 'item',
          url: '/ssb/filesinfo',
          target: false
        },
        {
          id: 'extraRec',
          title: 'Individual Receipts',
          type: 'item',
          url: '/accounts/extrareceipt',
          target: false
        }
      ]
    },
    {
      id: 'claims',
      title: 'Claims Management',
      type: 'collapse',
      icon: icons.IconCoin,
      children: [
        {
          id: 'processClaims',
          title: 'Process Claims',
          type: 'item',
          url: '/claims/selectBatch',
          target: false
        },
        {
          id: 'benefitsLookup',
          title: 'Benefits Look Up',
          type: 'item',
          url: '/claims/benefitsLookup',
          target: false
        },
        {
          id: 'claimsSearch',
          title: 'Search Claims',
          type: 'item',
          url: '/claims/claimsSearch',
          target: false
        }
      ]
    },
    {
      id: 'reports',
      title: 'Reports',
      type: 'collapse',
      icon: icons.IconPrinter,
      children: [
        {
          id: 'extraSumRec',
          title: 'Receipt Summary',
          type: 'item',
          url: '/reportsnew/receiptlist',
          target: false
        },
        {
          id: 'memberprovince',
          title: 'Members By Province',
          type: 'item',
          url: '/membershipreports/byprovince',
          breadcrumbs: false
        },
        {
          id: 'provincefiles',
          title: 'Monthly Files',
          type: 'item',
          url: '/membershipreports/byprovincefile',
          breadcrumbs: false
        },
        {
          id: 'memberage',
          title: 'Members By Age',
          type: 'item',
          url: '/membershipreports/byage',
          breadcrumbs: false
        },
        {
          id: 'retire',
          title: 'By Retirement',
          type: 'item',
          url: '/membershipreports/byretire',
          breadcrumbs: false
        },
        {
          id: 'membershipagestats',
          title: 'Membership Age Stats',
          type: 'item',
          url: '/reports/membershipagestats',
          breadcrumbs: false
        }
      ]
    }
  ]
};

export default branchUser;
